import React, { useRef, useEffect, forwardRef } from "react";
import PropTypes from "kf-proptypes/widgets";

import { RichTextEditor } from "@widgets/inputs/richtext/index.js";
import { Icon } from "@widgets/datadisplay/index.jsx";

import styles from "../richtext.css";

import RichtextIcon from "../icons/Richtext.svg";

function FormRichTextContainer(props) {
  const {
    showBorder,
    className,
    flowId,
    containerClassName = "",
    chipWrapperClassname = "",
    editorRef,
    editorContainerClassName,
    showRichtextLabel = true,
    ...restProps
  } = props;

  const currentEditorRef = useRef();

  useEffect(
    function setEditorRef() {
      if (currentEditorRef.current) {
        if (editorRef) {
          editorRef.current = currentEditorRef.current;
        }
      }
    },
    [currentEditorRef, editorRef]
  );

  return (
    <div
      className={`${containerClassName} ${styles.richtextcontainer} ${
        showBorder ? styles.richtextborder : ""
      }`}
    >
      {showRichtextLabel && (
        <div
          className={`${styles.richtextChipWrapper} ${chipWrapperClassname}`}
        >
          <Icon paddingNone className={styles.chipIcon}>
            <RichtextIcon fill="var(--kf-color-white)" />
          </Icon>
        </div>
      )}
      <RichTextEditor
        ref={currentEditorRef}
        {...restProps}
        inlineToolbar={true}
        flowId={flowId}
        containerClassname={`${editorContainerClassName} ${styles.defaultFormrichtextContainer} `}
        className={`${className} ${styles.richtext} ${
          showRichtextLabel ? styles.chipPadding : ""
        } ${showBorder ? styles.richtextbottomborder : ""}`}
      />
    </div>
  );
}

export const FormRichText = forwardRef((props, ref) => {
  return <FormRichTextContainer editorRef={ref} {...props} />;
});

FormRichText.propTypes = {
  /** If its enabled, an border will be shown for the outer container */
  showBorder: PropTypes.bool,
  /** If its `true` no actions can be performed. <b>[Deprecated]</b> Use Readonly component instead. */
  readOnly: PropTypes.bool,
  /** Wide variety of plugins to enable formatting, you need to pass it as an array for the required plugins. By default if no plugins is passed it will be an content-editable `div` */
  plugins: PropTypes.arrayOf(
    PropTypes.shape({
      formatType: PropTypes.string,
      component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
      hideInSlashCommand: PropTypes.bool
    })
  ),
  /** Input value to be passed to the editor, if its `markdown=true` it should be a String else array */
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  /** Class string which can be used to customise the editor */
  className: PropTypes.string,
  /** Flowid need to be passed for handling attachments using filepicker */
  flowId: PropTypes.string,
  /** Classname string for the outer container of the form */
  containerClassName: PropTypes.string,
  /** A ref to be passed to control the methods which is exposed */
  editorRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  }).isRequired,
  /** Classname string for the outer container of the editor */
  editorContainerClassName: PropTypes.string,
  /** If its enabled an icon will be shown for the form richtext in the left */
  showRichtextLabel: PropTypes.bool,
  /** Classname string for the icon container */
  chipWrapperClassname: PropTypes.string,
  /** An callback will be fired during onBlur */
  onBlur: PropTypes.func
};

FormRichText.defaultProps = {
  containerClassName: "",
  chipWrapperClassname: "",
  showRichtextLabel: true
};

FormRichTextContainer.propTypes = FormRichText.propTypes;

FormRichTextContainer.defaultProps = FormRichText.defaultProps;
